<div class="home-obituary">

	<h3 (click)="nav.goObituary()">Últimos falecidos <i class="fa fa-link"></i></h3>
	<app-big-loader *ngIf="loading" class="loading" />

	<p-tabView [scrollable]="true" styleClass="tabview-dead" *ngIf="!loading">
		<p-tabPanel *ngFor="let dead of list">
			<ng-template pTemplate="header">
				<div class="flex flex-row">
					<div class="flex flex-avatar">
						<mag-image
						[id]="dead.image_id"
						[height]="30" [width]="30"
						[alt]="dead.name"
						class="dead-avatar"
						/>
					</div>
					<div class="flex flex-name">
						<span class="font-bold white-space-nowrap m-0">{{ dead.name }}</span>
					</div>
				</div>
			</ng-template>

			<div class="death-box" (click)="goDead(dead)">

				<div class="ham-img">
					<mag-image
						[id]="dead.image_id"
						[width]="200"
						[height]="300"
						[alt]="dead.name"
					/>
				</div>
			
				<div class="flex flex-column post-prev-title death-data align-center">
					<span class="flex name font-alt">{{ dead.name }}</span>
					<!-- <span class="flex death-date"><i class="fa fa-cross icon"></i>{{ dead.death_date | date: 'dd/MM/yyyy' }}</span> -->
					<span class="flex death-info">
						<i class="fa fa-birthday-cake icon"></i>{{ dead.age }} anos
					</span>
					<span class="flex death-info">
						<i class="fa fa-medal icon"></i>{{ dead.winners }} {{ dead.winners == 1 ? "acertador" :  "acertadores" }}
					</span>
				</div>
			
			</div>

			</p-tabPanel>
	</p-tabView>


</div>